import React from "react";
import { useSelector } from "react-redux";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import PolicyRoundedIcon from "@mui/icons-material/PolicyRounded";
import PremiumHeader from "components/PremiumLanding/PremiumHeader";
import PremiumFooter from "components/PremiumLanding/PremiumFooter";
import "components/PremiumLanding/PremiumLanding.css";

export default function PrivacyPolicy() {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir() === "rtl";
  const auth = useSelector((state) => state.auth);
  const settings = useSelector((state) => state.settingsdata.settings) || {};

  return (
    <div className="premium-landing premium-public-page" dir={isRTL ? "rtl" : "ltr"}>
      <Helmet>
        <title>{t("privacy_policy")} | Garahex</title>
        <meta name="description" content={t("privacy_policy_para1")} />
      </Helmet>
      <a className="pl-skip-link" href="#pl-main-content">Skip to content</a>
      <PremiumHeader isLoggedIn={Boolean(auth && auth.profile && auth.profile.uid)} />

      <main id="pl-main-content" className="pl-public-main">
        <section className="pl-public-hero pl-legal-hero">
          <div className="pl-public-hero__glow" aria-hidden="true" />
          <div className="pl-container pl-public-hero__inner">
            <div className="pl-public-hero__copy pl-reveal is-visible">
              <p className="pl-eyebrow pl-eyebrow--light">LEGAL</p>
              <h1>{t("privacy_policy")}</h1>
            </div>
            <div className="pl-public-hero__panel" aria-hidden="true">
              <span><PolicyRoundedIcon /></span>
              <strong>GARAHEX</strong>
            </div>
          </div>
        </section>

        <section className="pl-public-section pl-legal-section">
          <div className="pl-container">
            <article className="pl-legal-document">
              <h2>{t("privacy_policy")}</h2>
              <p>{t("privacy_policy_para1")}</p>
              <p>{t("privacy_policy_para2")}</p>
              <p>{t("privacy_policy_para3")}</p>

              <p><strong>{t("privacy_policy_heading_info")}</strong></p>
              <p>{t("privacy_policy_info_para1")}</p>
              <ul>
                <li>{t("privacy_policy_info_list1")}</li>
                <li>{t("privacy_policy_info_list2")}</li>
                <li>{t("privacy_policy_info_list3")}</li>
                <li>{t("privacy_policy_info_list4")}</li>
              </ul>
              <p>{t("privacy_policy_info_para2")}</p>
              <p>{t("privacy_policy_info_para3")}</p>
              <p>{t("privacy_policy_info_para4")}</p>
              <ul>
                <li>{t("privacy_policy_info_list5")}</li>
                <li>{t("privacy_policy_info_list6")}</li>
                <li>{t("privacy_policy_info_list7")}</li>
              </ul>
              <p>{t("privacy_policy_info_para5")}</p>

              <p><strong>{t("privacy_policy_heading_log")}</strong></p>
              <p>{t("privacy_policy_log_para1")}</p>

              <p><strong>{t("privacy_policy_heading_cookie")}</strong></p>
              <p>{t("privacy_policy_cookie_para1")}</p>
              <p>{t("privacy_policy_cookie_para2")}</p>

              <p><strong>{t("privacy_policy_heading_service")}</strong></p>
              <p>{t("privacy_policy_service_para1")}</p>
              <ul>
                <li>{t("privacy_policy_service_list1")}</li>
                <li>{t("privacy_policy_service_list2")}</li>
                <li>{t("privacy_policy_service_list3")}</li>
                <li>{t("privacy_policy_service_list4")}</li>
              </ul>
              <p>{t("privacy_policy_service_para2")}</p>

              <p><strong>{t("privacy_policy_heading_security")}</strong></p>
              <p>{t("privacy_policy_security_para1")}</p>

              <p><strong>{t("privacy_policy_heading_link")}</strong></p>
              <p>{t("privacy_policy_link_para1")}</p>

              <p><strong>{t("privacy_policy_heading_children")}</strong></p>
              <p>{t("privacy_policy_children_para1")}</p>

              <p><strong>{t("delete_account_lebel").toUpperCase()}</strong></p>
              <p>{t("delete_account_msg")}</p>
              <p>{t("delete_account_subheading")}</p>
              <ul>
                <li>{t("delete_account_para1")}</li>
                <li>{t("delete_account_para2")}</li>
              </ul>

              <p><strong>{t("privacy_policy_heading_change_privacy")}</strong></p>
              <p>{t("privacy_policy_change_privacy_para1")}</p>
              <p>{t("privacy_policy_change_privacy_para2")}</p>

              <p><strong>{t("privacy_policy_heading_contact")}</strong></p>
              <p>
                {t("privacy_policy_contact_para1")}{" "}
                {settings && settings.contact_email ? (
                  <a href={`mailto:${settings.contact_email}`}><strong>{settings.contact_email}</strong></a>
                ) : null}
              </p>
            </article>
          </div>
        </section>
      </main>

      <PremiumFooter settings={settings} />
    </div>
  );
}
